import GridView from "graphics/icons/MediaControls/Views/GridView";
import PinnedView from "graphics/icons/MediaControls/Views/PinnedView";
import React from "react";
import { useSelector } from "react-redux";
import {
  tryEnlargeFirst,
  GRID_LAYOUT,
  SPACE_LAYOUT,
  tryOpenGrid,
  selectSpaceLayoutValue,
  PINNED_LAYOUT,
  openToSpaceLayout,
  selectRunningVideos,
  selectMeAdmin,
} from "slices/spaceMediaSlice";
import EfsTippy from "components/HOCS/EfsTippy";
import HelperTip from "components/HOCS/HelperTip";
import HlpExpandVideos from "components/HelpSlides/Spaces/HlpExpandVideos";
import { FM_EXPANDVIDEOS } from "helpers/freshman";
import SpaceView from "graphics/icons/Space/SpaceView";
import VideoView from "graphics/icons/Space/VideoView";
import MoreOptionsTippy from "components/HOCS/MoreOptionsTippy";
// import RemoteMediaOptions from "graphics/icons/MediaControls/RemoteMediaOptions";
import {
  exitFullScreen,
  lockSpace,
  openSpaceFullScreen,
  selectSpaceFullScreen,
  selectSpaceLocked,
  unlockSpace,
} from "slices/spaceSlice";
import RoomLink from "./RoomLink/RoomLink";
import ExitFullScreenSpace from "graphics/icons/MediaControls/SpaceControls/ExitFullScreenSpace";
import FullScreenSpace from "graphics/icons/MediaControls/SpaceControls/FullScreenSpace";
import SpaceLockedIcon from "graphics/icons/Space/SpaceLockedIcon";
import SpaceUnLockedIcon from "graphics/icons/Space/SpaceUnLockedIcon";

export const getVideoExpandOptions = (spaceLayoutValue, runningVideos) => {
  return [
    {
      text: (
        <>
          <PinnedView />
          &nbsp;&nbsp;Pinned View
        </>
      ),
      disabled: runningVideos < 1,
      active: spaceLayoutValue === PINNED_LAYOUT,
      action: () => {
        if (spaceLayoutValue === PINNED_LAYOUT) openToSpaceLayout();
        else tryEnlargeFirst();
      },
    },
    {
      text: (
        <>
          <GridView />
          &nbsp;&nbsp;Grid View
        </>
      ),
      disabled: runningVideos < 2,
      active: spaceLayoutValue === GRID_LAYOUT,
      action: () => {
        if (spaceLayoutValue === GRID_LAYOUT) openToSpaceLayout();
        else tryOpenGrid();
      },
    },
  ];
};

const SpaceBoxActiveControls = () => {
  const spaceLayoutValue = useSelector(selectSpaceLayoutValue);
  const runningVideos = useSelector(selectRunningVideos);
  const spaceFullScreen = useSelector(selectSpaceFullScreen);
  const spaceLocked = useSelector(selectSpaceLocked);
  const amAdmin = useSelector(selectMeAdmin);

  let videoOptions = getVideoExpandOptions(spaceLayoutValue, runningVideos);
  // let moreOptions = [];

  return (
    <>
      <div className="space-box-active-left">
        {amAdmin && <RoomLink />}
        <EfsTippy
          content={
            !amAdmin
              ? spaceLocked
                ? "Only Admins Can UnLock"
                : "Only Admins Can Lock"
              : spaceLocked
              ? "Unlock This Room"
              : "Lock This Room"
          }
          placement="top"
          className="normal-Tippy grey-Tippy"
          delay={[0, 0]}
        >
          <button
            onClick={amAdmin ? (spaceLocked ? unlockSpace : lockSpace) : null}
            className={`largey ${spaceLocked ? "locked-room" : ""} ${
              !amAdmin ? "cursor-default" : ""
            }`}
          >
            <span className="icony">
              {spaceLocked ? <SpaceLockedIcon /> : <SpaceUnLockedIcon />}
            </span>
            <span className="texty">{`Room ${
              spaceLocked ? "Locked" : "Unlocked"
            }`}</span>
          </button>
        </EfsTippy>
      </div>
      <div className="space-box-active-mid">
        <span className="change-viewer">Change View :</span>
        <HelperTip
          component={<HlpExpandVideos />}
          placement="top"
          style={{ width: "180px" }}
          code={FM_EXPANDVIDEOS}
          arrowWhite
        >
          <EfsTippy
            content={`${
              runningVideos < 1 ? "No Videos Nearby" : "Enlarge Videos"
            }`}
            placement="top"
            className={`normal-Tippy grey-Tippy ${
              runningVideos < 1 ? "disabled-info-tippy" : ""
            }`}
            delay={[0, 0]}
            hideOnClick={runningVideos > 0}
          >
            <MoreOptionsTippy
              options={videoOptions}
              placement="top"
              offset={[0, 20]}
              customStyle={{ width: "193px" }}
              disabled={runningVideos < 1}
            >
              <button
                className={`${
                  spaceLayoutValue === SPACE_LAYOUT ? "" : "active"
                }`}
              >
                <VideoView />
              </button>
            </MoreOptionsTippy>
          </EfsTippy>
        </HelperTip>
        <EfsTippy
          content="Room View"
          placement="top"
          className="normal-Tippy grey-Tippy"
          delay={[0, 0]}
        >
          <button
            className={`${spaceLayoutValue === SPACE_LAYOUT ? "active" : ""}`}
            onClick={
              spaceLayoutValue === SPACE_LAYOUT ? null : openToSpaceLayout
            }
          >
            <SpaceView />
          </button>
        </EfsTippy>
        {/* <EfsTippy
          content={`More`}
          placement="top"
          className="small-Tippy grey-Tippy"
          delay={[350, 0]}
          offset={[0, 15]}
        >
          <MoreOptionsTippy
            options={moreOptions}
            placement="top"
            offset={[0, 20]}
            customStyle={{ width: "193px" }}
          >
            <button disabled>
              <svg
                width="1"
                height="15"
                viewBox="0 0 1 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1"
                  width="15"
                  height="0.999999"
                  rx="0.5"
                  transform="rotate(90 1 0)"
                  fill="#A6A6A6"
                />
              </svg>
            </button>
          </MoreOptionsTippy>
        </EfsTippy> */}
        <EfsTippy
          content={`${spaceFullScreen ? "Exit Full Screen" : "Full Screen"}`}
          placement="top"
          className="normal-Tippy grey-Tippy"
          delay={[0, 0]}
        >
          <button
            className={`${spaceFullScreen ? "active" : ""}`}
            onClick={() => {
              if (spaceFullScreen) exitFullScreen();
              else openSpaceFullScreen();
            }}
          >
            {spaceFullScreen ? <ExitFullScreenSpace /> : <FullScreenSpace />}
          </button>
        </EfsTippy>
      </div>
    </>
  );
};
export default SpaceBoxActiveControls;
